@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/index-cards-3x5/master-kush-strain-index-card-stack-content/master-kush-strain-variant/master-kush-strain-variant.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
:host {
  --badge-grid-min-col: 0.875rem;
}
.product-card-variant-name {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 1rem;
  text-align: center;
  line-height: 100%;
  padding-bottom: 0.125rem;
}
.product-card-badges-strain-sizes-and-labels {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  position: relative;
  width: 100%;
  padding-bottom: 0.25rem;
}
.product-card-badges-strain-sizes-and-labels .badge-container {
  grid-column: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.25rem;
}
.product-card-badges-strain-sizes-and-labels .badge-container .badge {
  width: 0.875rem;
  height: 0.875rem;
}
.product-card-badges-strain-sizes-and-labels .product-card-strain-and-size {
  grid-column: 2;
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 0.25rem;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 0.6875rem;
  line-height: 100%;
  letter-spacing: 0.44px;
  text-align: center;
  margin-top: 0.125rem;
}
.product-card-badges-strain-sizes-and-labels .print-card-label {
  grid-column: 3;
}
.product-card-badges-strain-sizes-and-labels .print-card-label ::ng-deep .product-label {
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 0.5625rem;
  padding: 0.125rem;
  border-radius: 0.125rem;
  margin-left: 0;
  width: fit-content;
}
.product-card-properties-container {
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 0.75rem;
  line-height: 100%;
  letter-spacing: 0.24px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 0.375rem;
  text-align: center;
}
.product-card-properties-container .property-container {
  display: flex;
  flex-direction: row;
}
/*# sourceMappingURL=master-kush-strain-variant.component.css.map */
